// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1IAOCXzLyR3JOx {\n  display: flex;\n  align-self: center;\n  align-items: center;\n  height: 100%;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listCell": "_1IAOCXzLyR3JOx"
};
export default ___CSS_LOADER_EXPORT___;
